import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
    ModalOptions,
    ModalOptionsHelper,
    ModalSubjectData,
    ModalSujectDataHelper,
} from '../../models/b2b/modalSubjectData';
import { map } from 'rxjs/operators';

declare var noScroll: any;

@Injectable()
export class ModalsService {
    private openSubject = new BehaviorSubject<Map<string, ModalSubjectData>>(new Map());
    private openPanelSubject = new BehaviorSubject<ModalSubjectData>(null);

    getData(): Observable<Map<string, ModalSubjectData>> {
        return this.openSubject.asObservable();
    }

    private getDataByModalId(modalId: string): Observable<ModalSubjectData> {
        return this.getData().pipe(map((data: Map<string, ModalSubjectData>) => data.get(modalId)));
    }

    open(
        modalId: string,
        options: ModalOptions = ModalOptionsHelper.default(),
        data: any = null,
    ): Observable<ModalSubjectData> {
        let value = this.openSubject.getValue();
        if (value.has(modalId)) {
            return this.getDataByModalId(modalId);
        }
        options = options ? ModalOptionsHelper.create(options) : ModalOptionsHelper.default();
        value.set(modalId, { ...ModalSujectDataHelper.default(), modalId, options, data });
        this.openSubject.next(value);
        noScroll.on();
        return this.getDataByModalId(modalId);
    }

    close(modalId: string) {
        this.openSubject.getValue().delete(modalId);
        this.openSubject.next(this.openSubject.getValue());
        noScroll.off();
    }

    accept(modalId: string) {
        let value = this.openSubject.getValue();
        const modal = value.get(modalId);
        if (!modal) {
            return;
        }
        modal.accepted = true;
        this.openSubject.next(value);
        this.close(modalId);
    }

    cancel(modalId: string) {
        let value = this.openSubject.getValue();
        const modal = value.get(modalId);
        if (!modal) {
            return;
        }
        modal.cancelled = true;
        this.openSubject.next(value);
        this.close(modalId);
    }

    updateModalData(modalId: string, data: object) {
        const currentModalValue = this.openSubject.getValue().get(modalId);
        let value = this.openSubject.getValue();
        value.set(modalId, { ...currentModalValue, data: { ...currentModalValue.data, ...data } });
        this.openSubject.next(value);
    }

    /**Panel lateral */

    getPanelData(): Observable<ModalSubjectData> {
        return this.openPanelSubject.asObservable();
    }

    openPanel(panelId: string, data: any = null): Observable<ModalSubjectData> {
        this.openPanelSubject.next({ ...ModalSujectDataHelper.default(), modalId: panelId, data });
        noScroll.on();
        return this.getPanelData();
    }

    updatePanelData(data: object) {
        const panelData = this.openPanelSubject.getValue();
        this.openPanelSubject.next({ ...panelData, data: { ...panelData.data, ...data } });
    }

    closePanel() {
        this.openPanelSubject.next(undefined);
        noScroll.off();
    }
}
